import { render } from "./gamesReport.vue?vue&type=template&id=1514f4e8&scoped=true"
import script from "./gamesReport.vue?vue&type=script&lang=js"
export * from "./gamesReport.vue?vue&type=script&lang=js"

import "./gamesReport.vue?vue&type=style&index=0&id=1514f4e8&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1514f4e8"]])

export default __exports__